import React from 'react';
import { fontFamilies } from '../UI/Font';

export const OnlyOneLeft: React.FC<{ justifyContent?: string; lineHeight?: string }> = ({
  justifyContent,
  lineHeight,
}) => (
  <div className="only-one-left">
    <span>Only 1 left*</span>
    <style jsx>{`
      .only-one-left {
        display: flex;
        ${lineHeight ? `line-height: ${lineHeight}` : ''};
        ${justifyContent ? `justify-content: ${justifyContent}` : ''};
      }

      .only-one-left > span {
        color: #f25c5e;
        font-family: ${fontFamilies.bold};
      }
    `}</style>
  </div>
);
